// App-wide driver for the iOS mute-switch bypass.
//
// The actual mechanism lives in lib/audioEngine.ts, next to the ONE app-wide
// AudioContext that plays every sound — because the trick only works when the
// silent looping <audio> element is routed THROUGH that same context
// (createMediaElementSource), forcing it onto the iOS MEDIA channel (ignores the
// mute switch) instead of the ambient channel (silenced by it). A standalone
// element does not move our context — that was the earlier bug. Here we only wire
// the lifecycle: enable on the first user gesture (autoplay needs one), and pause
// while backgrounded so no stray now-playing player lingers on the lock screen.

import { enableMuteBypass, disableMuteBypass, wakeAudio } from './audioEngine';

let wired = false;

export function initAudioSession(): void {
  if (wired || typeof window === 'undefined') return;
  wired = true;
  window.addEventListener('pointerdown', enableMuteBypass);
  window.addEventListener('touchend', enableMuteBypass);
  window.addEventListener('keydown', enableMuteBypass);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) disableMuteBypass();
    else wakeAudio();
  });
  // visibilitychange only fires when the TAB is hidden — NOT when you switch to another
  // window (the tab stays "visible") or restore from the bfcache. Those returns also come
  // back with a suspended / interrupted / CLOSED context, so wake on window focus +
  // pageshow too. wakeAudio recreates a closed context, resumes (with a retry), and re-arms
  // the mute bypass — a cheap no-op when the context is already running.
  window.addEventListener('focus', wakeAudio);
  window.addEventListener('pageshow', wakeAudio);
  enableMuteBypass();
}
